module.exports = __webpack_public_path__ + "static/img/cont58_05.10e021c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_05.jpg
// module id = cwaP
// module chunks = 0